
import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "advertiser";
const options = { role: ROLE.ADVERTISER };

export const createStream = async (values) => {
  return await axiosInstance(options).post(`${path}/streams/create-stream`, values);
};

export const GetStreamsDetails = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-streams`, value);
}


export const startStream = async (value) => {
  return await axiosInstance(options).put(`${path}/streams/start-stream`, value);
}
export const GetLiveCaptions = async (blob, streamId, lang = 'hi') => {
  return axiosInstance(options).post(`${path}/streams/stt?language=${lang}&streamId=${encodeURIComponent(streamId)}`, blob, {
    headers: {
      "Content-Type": blob.type || "application/octet-stream",
    },
  });
};

export const createAndForwardStream = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/start-and-forward-streamweb`, value);
}
export const getLiveStreamProducts = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-products`, value);
}

export const endStream = async (value) => {
  return await axiosInstance(options).put(`${path}/streams/end-stream-live`, value);
}


export const startStreamApi = async (value) => {
  return await axiosInstance(options).put(`${path}/streams/start-stream`, value);
}



export const getStreamProducts = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-products`, value);
}
export const getStreamDetails = async (id) => {
  return await axiosInstance(options).post(`${path}/streams/get-stream-details`, { id });
};

export const initMultipartUpload = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/upload/multipart/init`, value);
};

export const uploadMultipartChunk = async (urlParams, blob) => {
  return axiosInstance(options).post(`${path}/streams/upload/multipart/part?${urlParams}`, blob, {
    headers: {
      "Content-Type": "application/octet-stream",
    },
  });
};

export const completeMultipartUpload = async (value) => {
  return await axiosInstance(options).post(`${path}/streams/upload/multipart/complete`, value);
};
export const getStreamComments = async (stream_id) => {
  return await axiosInstance(options).post(`/user/streams/get-stream-comments`, { stream_id });
};

export const getProductList = async (data = {}) => {
  return await axiosInstance(options).post(`advertiser/products/product-list`, data);
};

export const deleteStream = async (streamId) => {
  return await axiosInstance(options).delete(`${path}/streams/delete-stream?stream_id=${streamId}`);
};
